module.exports = __webpack_public_path__ + "static/fonts/SCDream4.14cc8f9.otf";